<app-header></app-header>

<section class="bredcrumb">
    <div class="container">
        <ul class="brd-nav">
            <li> <a [routerLink]="['/']"> Home </a></li>
            <li> <a [routerLink]="['/doctors/list']"> Doctors </a></li>
            <li><span> Chat </span></li>
        </ul>
    </div>
</section>
<!--- End of bredcrumb --->

<section class="single-page doctors-detail doctors-detail-chat padd-row">
    <div class="container">
        <div class="row">
            <div class="col-lg-4">
                <div class="doc-detail-lft p-0 sidebar">

                        <div class="doc-detail-box grey-bg p-25-side mb-4">
                                <div class="doctor-box-top">
                                    <div class="doctor-box-img">
                                        <img [src]="userData.profilePicture" alt="image">
                                    </div>
                                    <div class="doctor-box-top-cnt">
                                        <h5> {{ userData.name }}
                                            <span> Patient </span>
                                            <span> {{ userData.phoneNo }} </span>
                                        </h5>
                                        <div class="doctor-box-adres">
                                            <p> {{ userData.address }} {{ userData.city ? ',' + userData.city : ''  }}
                                                 {{ userData.pincode ? ',Pin Code-' + userData.pincode : '' }} </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="doc-detail-btm">
                                    <a [routerLink]="['/user-profile']" class="btn-style"> View Profile </a>
                                </div>
                            </div>


                    <div class="doc-detail-box grey-bg p-25-side">
                        <div class="doctor-box-top">
                            <div class="doctor-box-img">
                                <img [src]="doctorData.profilePicture ? doctorData.profilePicture : 'assets/images/doc-img-2.jpg'" alt="image">
                            </div>
                            <div class="doctor-box-top-cnt">
                                <h5>  {{ doctorData?.name }} <span> {{ doctorData?.speciality }} |  {{ doctorData?.education }} </span></h5>
                                <div class="doctor-box-rating">
                                    <i *ngFor='let in of counter(parseInt(doctorData?.rating)) ;let i = index' class="fa fa-star" aria-hidden="true"></i>
                                    <i class="fa fa-star-o"   *ngFor='let in of counter(5- parseInt(doctorData?.rating)) ;let i = index'  aria-hidden="true"></i> 
                                    <!-- <span *ngIf="doctorData.rating" [innerHTML]="parseInt(doctorData?.rating)"> </span>
                                    <span *ngIf="!doctorData.rating"> 0 </span> -->
                                    <p> {{ doctorData?.review }} Reviews </p>
                                </div>
                            </div>
                        </div>
                        <div class="doc-detail-btm">
                            <a [routerLink]="['/doctors/detail/'+doctorData.uniquekey]" class="btn-style"> View Profile </a>
                        </div>
                    </div>

                    

                </div>
            </div>

            <div class="col-lg-8">
                <div class="white-bg-shadow doc-chat-right-side">
                    <div class="doc-chat-header">
                        <h3> Chat </h3>
                    </div>
                    <div #scrollMe class="doc-chat-body">
                        <div *ngFor="let message of messages" [ngClass]="message.sentBy=='DOCTOR' ? 'doc-chat-box-row doc-chat-box-row-doc clearfix' : 'doc-chat-box-row clearfix'">
                            <div class="doc-chat-box-main">
                                <div class="doc-chat-box-img">
                                    <img  [src]="message.sentBy=='DOCTOR' ? message.doctorProfilePicture : message.userProfilePicture" alt="image">
                                </div>
                                <div *ngIf="message.messageType=='TEXT' || !message.messageType" class="doc-chat-box-cnt">
                                    <p> {{ message.message }} </p>
                                </div>
                                <div *ngIf="message.messageType=='IMAGE'" class="doc-chat-box-cnt">
                                <img style="cursor:pointer" (click)="showPreview(message.message)" [src]="message.message"
                                >
                                </div>
                                <div *ngIf="message.messageType=='PDF'" class="doc-chat-box-cnt">
                                   <a [href]="message.message"> <img src="assets/images/pdf.jpeg"
                                    ></a>
                                    </div>
                            </div>
                        </div>
                        
                       
                    </div>
                    <div class="doc-chat-ftr">
                        <div class="doc-chat-ftr-box">
                            <div class="doc-chat-ftr-box-lft">
                                <i (click)="fileAttach.click()" class="fa fa-plus" aria-hidden="true"></i>
                                <input type="text" (keyup.enter)="sendMessage()" [(ngModel)]="inputMessage" class="form-control" placeholder="Write something here..">
                            </div>
                            <div class="doc-chat-ftr-box-right">
                                <a [routerLink]="null" (click)="sendMessage()" class="btn-style"> Send </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<input type="file" #fileAttach style="display:none;" accept=".png, .jpg, .jpeg, .pdf" (click)="fileAttach.value = null" value="" (change)="fileChanged($event)">
<!--- End of doctors-detail --->


<input type="hidden" id="orderImagesCLick" data-toggle="modal" data-target="#orderImagesModal">

<!-- The Modal -->
<div class="modal fade"  id="orderImagesModal">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Image Preview</h5>
      </div>
      <!-- Modal body -->
      <div class="modal-body text-center">
            <slideshow
            [minHeight]="'525px'"
            [showArrows]="imageUrlArray.length>1 ? true: false"
            [imageUrls]="imageUrlArray"></slideshow>
        <button class="btn btn-primary" style="margin-top: 20px;"
 data-toggle="modal" data-target="#orderImagesModal">OK</button>

      </div>
    </div>
  </div>
</div>



<ngx-spinner></ngx-spinner>